import m from "../../../../geodata/es2015/region/usa/vtHigh";
window.am4geodata_region_usa_vtHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/vtHigh.js
// module id = null
// module chunks = 